// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__uL1Yi","l3":"Loading_l3__lRyiI"};